import { Statistic } from 'antd';
import React from 'react';
import PropTypes from 'prop-types';
import Async from '../../../core/layout/Async';
import Icon from '../../../core/layout/Icon';

const SystemTranslationStatistic = (props) => (
  <Async fetching={props.fetching}>
    <Statistic
      title={props.title}
      value={props.value}
      groupSeparator=""
      suffix={
        <Icon
          name={props.icon}
          onClick={props.onClick}
          style={{
            fontSize: '30px',
          }}
        />
      }
    />
  </Async>
);

SystemTranslationStatistic.propTypes = {
  title: PropTypes.string.isRequired,
  value: PropTypes.number.isRequired,
  icon: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  fetching: PropTypes.bool.isRequired,
};

export default SystemTranslationStatistic;
